import React from "react"
import { ThemeProvider } from "@emotion/react";
import { CssBaseline, GlobalStyles } from "@mui/material"
import { light } from "../themes/light";
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { closeSnackbar, SnackbarProvider } from 'notistack'
import { GenericIconButton } from "../components/generic/GenericIconButton";
import { X } from "@phosphor-icons/react";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";

const queryClient = new QueryClient();
export const MuiThemeProvider = ({ children }) => {
  return (
    <ThemeProvider theme={light}>
      <QueryClientProvider client={queryClient}>
        <SnackbarProvider
          maxSnack={3}
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'right',
          }}
          action={(snackbarId) => <GenericIconButton
            icon={<X size={16} color="#FFF" />}
            onClick={() => closeSnackbar(snackbarId)}
          />}
        >
          <CssBaseline />
          <GlobalStyles
            styles={{
              '::-webkit-scrollbar': {
                width: '4px',
                height: '4px',
              },
              '::-webkit-scrollbar-thumb': {
                backgroundColor: '#DFE3E8',
                borderRadius: '10px',
              },
            }}
          />
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            {children}
          </LocalizationProvider>
        </SnackbarProvider>
      </QueryClientProvider>
    </ThemeProvider>
  )
}